import React from 'react';
import { Greyscale } from 'glints-aries';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CheckboxWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: left;
`;

const Input = styled.input`
  display: none;
  z-index: 2;
  width: 20px;
  height: 20px;
  position: relative;
  top: 2px;
  cursor: pointer;

  + label {
    position: relative;
    cursor: pointer;
    &:before {
      content: ' ';
      position: absolute;
      top: 0;
      width: 20px;
      height: 20px;
      display: block;
      background: ${Greyscale.white};
      border: 1px solid ${Greyscale.grey};
    }

    &:after {
      content: ' ';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 15px;
      height: 15px;
      display: block;
      z-index: 1;
      background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9
      IjE4MS4yIDI3MyAxNyAxNiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAxODEuMiAyNzMgMTcgMTYiPjxwYXRoIGQ9Ik0tMzA2LjMgNTEuMm
      wtMTEzLTExM2MtOC42LTguNi0yNC04LjYtMzQuMyAwbC01MDYuOSA1MDYuOS0yMTIuNC0yMTIuNGMtOC42LTguNi0yNC04LjYtMzQuMyAwb
      C0xMTMgMTEzYy04LjYgOC42LTguNiAyNCAwIDM0LjNsMjMxLjIgMjMxLjIgMTEzIDExM2M4LjYgOC42IDI0IDguNiAzNC4zIDBsMTEzLTEx
      MyA1MjQtNTI0YzctMTAuMyA3LTI1LjctMS42LTM2eiIvPjxwYXRoIGZpbGw9IiMzNzM3MzciIGQ9Ik0xOTcuNiAyNzcuMmwtMS42LTEuNmM
      tLjEtLjEtLjMtLjEtLjUgMGwtNy40IDcuNC0zLjEtMy4xYy0uMS0uMS0uMy0uMS0uNSAwbC0xLjYgMS42Yy0uMS4xLS4xLjMgMCAuNWwzLj
      MgMy4zIDEuNiAxLjZjLjEuMS4zLjEuNSAwbDEuNi0xLjYgNy42LTcuNmMuMy0uMS4zLS4zLjEtLjV6Ii8+PHBhdGggZD0iTTExODcuMSAxN
      DMuN2wtNTYuNS01Ni41Yy01LjEtNS4xLTEyLTUuMS0xNy4xIDBsLTI1My41IDI1My41LTEwNi4yLTEwNi4yYy01LjEtNS4xLTEyLTUuMS0x
      Ny4xIDBsLTU2LjUgNTYuNWMtNS4xIDUuMS01LjEgMTIgMCAxNy4xbDExNC43IDExNC43IDU2LjUgNTYuNWM1LjEgNS4xIDEyIDUuMSAxNy4
      xIDBsNTYuNS01Ni41IDI2Mi0yNjJjNS4yLTMuNCA1LjItMTIgLjEtMTcuMXpNMTYzNC4xIDE2OS40bC0zNy43LTM3LjdjLTMuNC0zLjQtOC
      42LTMuNC0xMiAwbC0xNjkuNSAxNjkuNS03MC4yLTcxLjljLTMuNC0zLjQtOC42LTMuNC0xMiAwbC0zNy43IDM3LjdjLTMuNCAzLjQtMy40I
      DguNiAwIDEybDc3LjEgNzcuMSAzNy43IDM3LjdjMy40IDMuNCA4LjYgMy40IDEyIDBsMzcuNy0zNy43IDE3NC43LTE3Ni40YzEuNi0xLjcg
      MS42LTYuOS0uMS0xMC4zeiIvPjwvc3ZnPg==')
        no-repeat center center;
      transition: all 0.3s ease;
      transform: scale(0);
      opacity: 0;
    }

    span {
      padding-left: 2em;
    }
  }

  &:checked + label:before {
    border: 2px solid ${Greyscale.black};
  }

  &:checked + label:after {
    transform: scale(1);
    opacity: 1;
  }
`;

const Label = styled.label`
  color: ${Greyscale.grey};
  font-size: 12px;
`;

const Checkbox = props => (
  <CheckboxWrapper>
    <Input id={props.id} type="checkbox" {...props} />
    <Label htmlFor={props.id}>
      <span>{props.label}</span>
    </Label>
  </CheckboxWrapper>
);

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
  checked: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default Checkbox;
